import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL } from './urls'

// 列表
async function list (query) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL}`,
      method: 'GET',
      params: query
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL}/${id}`,
      method: 'DELETE'
    }
  )
}

export default {
  list,
  insert,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-promotion-code.js